import { post, get } from '@/utils/request';

const url = {
  subjectActivityInfo: '/activity/open/subjectActivityInfo',
  provideActivityInfo: '/activity/open/provideActivityInfo',
};

export default {
  getSubjectActivityInfo(params = {}, options = {}) {
    return post({
      url: url.subjectActivityInfo,
      data: params,
      options,
    });
  },
  getProvideActivityInfo(params = {}, options = {}) {
    return post({
      url: url.provideActivityInfo,
      data: params,
      options,
    });
  },
};
